class Form {
  constructor() {
    let initFunc = () => {
      requestGeolocation();
    }

    let requestGeolocation = () => {
      if ("geolocation" in navigator) {
        try {
          navigator.geolocation.getCurrentPosition(
            success,
            (err) => {
              console.log("Form: Erreur de géolocalisation:", err.code, err.message);
            },
            {
              enableHighAccuracy: true,
              timeout: 15000,
              maximumAge: 0
            }
          );
        } catch (e) {
          error(e);
        }
      } else {
        error(new Error("Geolocation not supported"));
      }
    };

    function success(position) {
        // Mode test : décommenter ces lignes pour simuler une localisation à Montréal
        // const testMode = true;
        // const latitude = testMode ? 45.5017 : position.coords.latitude;
        // const longitude = testMode ? -73.5673 : position.coords.longitude; 
        
        // Mode normal
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        
        const cityFieldElement = document.querySelector('form input[data-name="city"]');
        if (cityFieldElement && cityFieldElement.closest('._form_element')) {
            cityFieldElement.closest('._form_element').style.display = "none";
        }
        
        const preferredLocationElement = document.querySelector('form select[name="field[20]"]');
        if (preferredLocationElement && preferredLocationElement.closest('._form_element')) {
            preferredLocationElement.closest('._form_element').style.display = "none";
        }
        
        const preferredLocation = determinePreferredLocation(latitude, longitude);
        
        if (preferredLocation) {
            console.log('Preferred Location sélectionnée:', preferredLocation);
            sessionStorage.setItem("preferredLocation", preferredLocation);
            
            updatePreferredLocationField(preferredLocation);
        } else {
            // Ce cas ne devrait plus se produire car nous retournons toujours une valeur par défaut
            console.log('Aucune Preferred Location déterminée, utilisation de la valeur par défaut');
            sessionStorage.removeItem("preferredLocation");
        }
        
        // Utiliser OpenStreetMap Nominatim pour le géocodage inverse
        fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=10&accept-language=fr`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Erreur réseau lors de la récupération des données de localisation');
                }
                return response.json();
            })
            .then(data => {
                // Extraire la ville des données OpenStreetMap
                let city = data.address.city || 
                           data.address.town || 
                           data.address.village || 
                           data.address.hamlet || 
                           data.address.municipality ||
                           data.address.county;
                
                if (city) {
                    const cityFields = document.querySelectorAll('form input[data-name="city"]');
                    cityFields.forEach(field => {
                        field.value = city;
                    });
                    
                    sessionStorage.setItem("city", city);
                    
                    // Vérifier si le champ city existe dans le formulaire ActiveCampaign
                    const acForm = document.getElementById('_form_1_');
                    if (acForm) {
                        let acCityField = acForm.querySelector('input[data-name="city"]');
                        
                        if (!acCityField) {
                            acCityField = document.createElement('input');
                            acCityField.type = 'hidden';
                            acCityField.name = 'field[1]';
                            acCityField.id = 'field[1]';
                            acCityField.setAttribute('data-name', 'city');
                            acForm.appendChild(acCityField);
                        }
                        
                        acCityField.value = city;
                    }
                } else {
                    // Réafficher le champ city si aucune ville n'est trouvée
                    if (cityFieldElement && cityFieldElement.closest('._form_element')) {
                        cityFieldElement.closest('._form_element').style.display = "block";
                    }
                }
            })
            .catch(error => {
                // Réafficher le champ city en cas d'erreur
                if (cityFieldElement && cityFieldElement.closest('._form_element')) {
                    cityFieldElement.closest('._form_element').style.display = "block";
                }
            });
      }
      
      // Fonction pour déterminer la Preferred Location en fonction des coordonnées
      function determinePreferredLocation(latitude, longitude) {
        // Coordonnées des emplacements
        const locations = {
            "Calgary Deerfoot Meadows": {
                lat: 51.0447,
                lng: -114.0719,
                city: "Calgary"
            },
            "Winnipeg": {
                lat: 49.8951,
                lng: -97.1384,
                city: "Winnipeg"
            }
        };
        
        // Calculer la distance entre deux points géographiques (formule de Haversine)
        function calculateDistance(lat1, lon1, lat2, lon2) {
            const R = 6371; // Rayon de la Terre en km
            const dLat = (lat2 - lat1) * Math.PI / 180;
            const dLon = (lon2 - lon1) * Math.PI / 180;
            const a = 
                Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
                Math.sin(dLon/2) * Math.sin(dLon/2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            const distance = R * c; // Distance en km
            return distance;
        }
        
        // Trouver l'emplacement le plus proche
        let closestLocation = null;
        let minDistance = Infinity;
        
        for (const [name, coords] of Object.entries(locations)) {
            const distance = calculateDistance(latitude, longitude, coords.lat, coords.lng);
            
            if (distance < minDistance) {
                minDistance = distance;
                closestLocation = name;
            }
        }
        
        const distanceThreshold = 500;
        
        // Si la distance est inférieure au seuil, retourner l'emplacement
        if (minDistance <= distanceThreshold) {
            return closestLocation;
        }
        
        // Si l'utilisateur est trop loin, retourner Calgary Deerfoot Meadows par défaut
        return "Calgary Deerfoot Meadows";
      }
      
      function updatePreferredLocationField(preferredLocation) {
        const acForm = document.getElementById('_form_1_');
        if (!acForm) return;
        
        let preferredLocationField = acForm.querySelector('select[name="field[20]"]');
        
        if (preferredLocationField) {
            if (preferredLocationField.closest('._form_element')) {
                preferredLocationField.closest('._form_element').style.display = "none";
            }
            
            // Sélectionner l'option correspondante
            for (let i = 0; i < preferredLocationField.options.length; i++) {
                if (preferredLocationField.options[i].text === preferredLocation) {
                    preferredLocationField.selectedIndex = i;
                    break;
                }
            }
        } else {
            // Si le champ n'existe pas ou n'est pas un select, créer un champ caché
            preferredLocationField = document.createElement('input');
            preferredLocationField.type = 'hidden';
            preferredLocationField.name = 'field[20]';
            preferredLocationField.setAttribute('data-name', 'preferred_location');
            preferredLocationField.value = preferredLocation;
            acForm.appendChild(preferredLocationField);
        }
      }
    
      function error(err) {
        console.log('Form: Erreur de géolocalisation', err);
        
        // Vérifier si le formulaire ActiveCampaign existe
        const acForm = document.getElementById('_form_1_');
        if (acForm) {
          const cityFieldElement = document.querySelector('form input[data-name="city"]');
          if (cityFieldElement && cityFieldElement.closest('._form_element')) {
            cityFieldElement.closest('._form_element').style.display = "block";
          }
          
          const preferredLocationElement = document.querySelector('form select[name="field[20]"]');
          if (preferredLocationElement && preferredLocationElement.closest('._form_element')) {
            preferredLocationElement.closest('._form_element').style.display = "block";
          }
        }
      }

    initFunc();
  };
}

export { Form }
